module.exports = __webpack_public_path__ + "static/getinspired-hero3-alt-e23d58db549c518b2276f6854bd911d1.jpg";